import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const GetspeakersSlice = createSlice({
  name: 'getspeakers',
  initialState,
  reducers: {
    Get_speakers_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Get_speakers_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Get_speakers_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Get_speakers_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Get_speakers_request, Get_speakers_success, Get_speakers_failure, Clear_Get_speakers_Check } = GetspeakersSlice.actions

export default GetspeakersSlice.reducer